import { getAreaId, isSameId } from "../../helpers";
export default function (store, { overAreaId, before }) {
    const { dragItemAreaId, areasMeta } = store.getState();
    if (!overAreaId || !dragItemAreaId) {
        return;
    }
    const overAreaMeta = areasMeta[overAreaId];
    const dragItemArea = areasMeta[dragItemAreaId];
    const moveInSameArea = isSameId(overAreaId, getAreaId(dragItemArea.columnId || "", dragItemArea.rowId));
    if (overAreaMeta.noFreeSpace && !moveInSameArea) {
        return;
    }
    store.setState({
        overAreaId,
        before,
    });
}
//# sourceMappingURL=drag.js.map